import { Action } from "@ngrx/store";

import { ViewState } from "./state";

export type Actions = Update;

export class Update implements Action {
    static readonly type = "view/update";
    readonly type = Update.type;

    private constructor(
        public key: keyof ViewState,
        public value: any,
    ) {}

    public static create<Key extends keyof ViewState, T>(
        key: Key,
        value: ViewState[Key],
    ): Update {
        return new Update(key, value);
    }
}
